import plataformaApi from '@/services/plataforma/lti';
import plataformaApiLti from '@/services/plataforma/contentv2/content';
import plataformaApiSafeA from '@/services/plataforma/safeA';

export default {
  async actionLtiLaunch(_, parameters) {
    return plataformaApi.getLtiForm(parameters);
  },
  async actionLtiResolve({ commit }) {
    return plataformaApi.postLtiIntegration();
  },
  async actionCheckToken({ commit }) {
    return plataformaApiSafeA.checkToken()
      .then((response) => {
        commit('plataforma/user/SET_USER_LTI_ACCESS', response.data.payloadToken.authMode === 'lti', { root: true });
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },
  async actionLTIDefault() {
    return plataformaApiLti.getLTIDefault().then((response) => {
      return Promise.resolve(response.data);
    })
      .catch((e) => {
        return Promise.reject(e.response);
      });;
  },
  async actionAuthenticateSafeALegacyV3() {
    return plataformaApiSafeA.authenticateSafeALegacyV3()
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  }
};
